import { CogSyncOutlineIcon } from './CogSyncOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 204F6FF9-EFD1-4B79-9DDF-2642984189F0
 * name cog-sync-outline
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cog-sync-outline.svg
 * tags
 * - Settings 
 */
export const SettingsSyncOutlineIcon = CogSyncOutlineIcon;
export default SettingsSyncOutlineIcon